import { createFileRoute, redirect } from "@tanstack/react-router";
import { getSession } from "@/lib/auth-client";

export const Route = createFileRoute("/")({
  component: RouteComponent,
  beforeLoad: async () => {
    const { data: session, error } = await getSession();
    if (error || !session) {
      throw redirect({
        to: "/auth/signin",
      });
    }
    // User is authenticated, redirect to dashboard
    throw redirect({
      to: "/dashboard",
    });
  },
});

function RouteComponent() {
  // This won't render because beforeLoad always redirects
  return null;
}
